// Устанавливает необходимые мета теги в документ

interface MetaTagInfo {
	title: string;
}

function setTitle(titleName: string) {
	document.querySelector('title')?.remove();

	const title = document.createElement('title');
	title.text = titleName;
	document.getElementsByTagName('head')[0].appendChild(title);
}

function setFavicon(path: string) {
	const link: HTMLLinkElement =
		document.querySelector("link[rel*='icon']") || document.createElement('link');
	link.type = 'image/x-icon';
	link.rel = 'shortcut icon';
	link.href = path;
	document.getElementsByTagName('head')[0].appendChild(link);
}

export default function (info: MetaTagInfo) {
	setTitle(info.title);
	setFavicon('https://borisbot.com/favicon.ico');
}
